<div cdkDrag cdkDragRootElement=".cdk-overlay-pane">
<div cdkDragHandle class="header">
    <div>Rule {{ruleNo}}</div>
    <div>Rule Name: {{ruleName}}</div>
</div>
<mat-dialog-content>
  <table class="editor-table">
    <tr>
        <td class="headername">{{title}}</td>
        <td class="operatorsheader">Operators</td>
    </tr>

    <tr>
        <td>
        <span class="left-label">{{targetField}} =</span>
        </td>

        <td>
        <div class="operators">
            <button
            matMiniFab
            *ngFor="let op of operators"
            (click)="insertOperator(op)">
            {{op}}
            </button>
        </div>
        </td>
    </tr>
    <tr>
        <td colspan="2">
            <div class="expression-row">
                <div class="expression-editor"
                    contenteditable="true"
                    #editor>
                </div>
            </div>
        </td>
    </tr>
  </table>

  <div class="headername">Field Selector</div>
  <div class="table-container">
    <mat-form-field class="filter-field">
        <input matInput (keyup)="applyFilter($event)" placeholder="Type to filter..." #input>
    </mat-form-field>
    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8">
        <ng-container matColumnDef="field">
        <th mat-header-cell *matHeaderCellDef>Field Name</th>
        <td mat-cell *matCellDef="let element">
        <span [style.color]="element.color">{{element.name}}</span>
        </td>
        </ng-container>

        <ng-container matColumnDef="type">
        <th mat-header-cell *matHeaderCellDef>Data Type</th>
        <td mat-cell *matCellDef="let element">
            <span style="color: #ffffffb3;">{{element.dataType}}</span>
        </td>
        </ng-container>

        <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element">
            <button mat-button (click)="insertField(element.name,element.color)">Insert >></button>
        </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button (click)="save()" mat-raised-button color="primary">SAVE</button>
  <button (click)="cancel()" mat-button mat-dialog-close>CANCEL</button>
</mat-dialog-actions>
</div>